import { formatPosition } from ".";
import { formatDeliveryPositionSalary } from "./delivery-position-salary";

export function formatDeliveryPosition(positionData) {
    const formattedData = {
        ...formatPosition(positionData),
        ...formatDeliveryPositionSalary(positionData),
    };
    return formattedData;
}
